import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { isGrounds } from '@src/utils/app';
import { getDispatchAction } from '@src/utils/url';
import { jumpPageUrl, gotoNewPage, getSplit, getPaofangNum } from '@src/utils';
import { debounce } from '@ifeng-fe/ui_base';

const Layout = ({ list }) => {
    const [content, setContent] = useState([]);
    const [state, setState] = useState(0);
    const btnText = [
        { text: '上映时间', sortProp: 'dateSort' },
        { text: '综合评分', sortProp: 'scoreSortNum' },
        { text: '预测票房', sortProp: 'piaofangSortNum' },
        { text: '实际票房', sortProp: 'piaofanRealgSortNum' },
    ];
    const gotoDetail = (item) => {
        return () => {
            const { jumpType, otherInfo, detail = {} } = item;

            if (jumpType === '1') {
                const { voteId } = detail;

                gotoNewPage({ type: 'web', url: `${jumpPageUrl()}/detail/${voteId}` })();
            } else {
                const { url, id } = otherInfo;
                const type = jumpType === '0' ? 'special' : 'article';
                const jumpUrl = getDispatchAction(url, type, id, isGrounds);

                gotoNewPage({ type: jumpUrl[0], url: jumpUrl[1] })();
            }
        };
    };

    const sortList = (content, index) => {
        const { sortProp } = btnText[index];
        const contentNew = [...content].sort((a, b) => b[sortProp] - a[sortProp]);

        return contentNew;
    };

    const changeActiive = (index) => {
        return debounce(() => {
            setState(index);

            setContent(sortList(content, index));
        });
    };

    useEffect(() => {
        const listNew = [...list].map((item) => {
            const { score, piaofang, realpiaofang, date } = item;
            const [piaofangNum = 0, danwei = '亿'] = getSplit(piaofang);
            const [realpiaofangNum = 0, realdanwei = '亿'] = getSplit(realpiaofang);
            const [scoreNum, scoreDanwei = '分'] = getSplit(score);
            const piaofangSortNum = getPaofangNum(danwei, piaofangNum);
            const piaofanRealgSortNum = getPaofangNum(realdanwei, realpiaofangNum);

            return {
                ...item,
                piaofangNum,
                danwei,
                realpiaofangNum,
                realdanwei,
                scoreNum,
                scoreDanwei,
                piaofangSortNum,
                piaofanRealgSortNum,
                scoreSortNum: parseFloat(scoreNum),
                dateSort: new Date(date).getTime(),
            };
        });

        setContent(sortList(listNew, state));
    }, []);

    return (
        <div className={styles.layout}>
            <div className={styles.bannerheader}>
                <div className={styles.btnbox}>
                    {btnText.map((item, index) => {
                        return (
                            <div className={index === state ? `${styles.btn} ${styles.active}` : `${styles.btn}`} key={index} onClick={changeActiive(index)}>
                                {item.text}
                            </div>
                        );
                    })}
                </div>
            </div>
            {content.map((item, index) => {
                const { score, piaofang, realpiaofang, piaofangNum, danwei, realpiaofangNum, realdanwei, scoreNum, scoreDanwei } = item;

                return (
                    <div className={styles.item} key={index} onClick={gotoDetail(item)}>
                        <div className={index < 3 ? `${styles.order}` : `${styles.ordercommon}`}>{index + 1}</div>
                        <div className={styles.itemdetail}>
                            <div className={styles.titlebox}>
                                <div className={styles.title}>{item.title}</div>
                                <div className={styles.date}>{item.date}上映</div>
                            </div>

                            <div className={styles.container}>
                                <img src={item.thumbnail} className={styles.img} />
                                <div className={styles.info}>
                                    <div className={styles.scorebox}>
                                        <div className={state === 1 ? `${styles.btn} ${styles.active}` : `${styles.btn}`}>
                                            <span>{scoreNum}</span>
                                            {scoreDanwei}
                                        </div>
                                        <div className={state === 2 ? `${styles.btn} ${styles.active}` : `${styles.btn}`}>
                                            <span>{piaofangNum}</span>
                                            {danwei}
                                        </div>
                                        <div className={state === 3 ? `${styles.btn} ${styles.active}` : `${styles.btn}`}>
                                            <span>{realpiaofangNum}</span>
                                            {realdanwei}
                                        </div>
                                    </div>

                                    <div className={styles.comment}>
                                        <div className={styles.commentdetial}>{item.intro}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={styles.line} />
                    </div>
                );
            })}
        </div>
    );
};

Layout.propTypes = {
    list: PropTypes.object,
};

export default errorBoundary(Layout);
